import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogRef } from '@angular/material/dialog';
import { Supplier } from '../../../interface/supplier';
import { CommonModule } from '@angular/common';
import { MatCardSubtitle, MatCardTitle } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatOption, MatSelect } from '@angular/material/select';
import { MatButton } from '@angular/material/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-choose-card-adm',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    MatCardTitle,
    MatCardSubtitle,
    MatFormFieldModule,
    MatSelect,
    MatOption,
    MatDialogActions,
    MatButton,
  ],
  templateUrl: './choose-card-adm.component.html',
  styleUrls: ['./choose-card-adm.component.scss']
})
export class ChooseCardAdmComponent {

  public selectedAdm: Supplier = { id: '' };
  public cardAdms: Supplier[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: { cardAdms?: Supplier[] },
    private dialogRef: MatDialogRef<ChooseCardAdmComponent>
  ) {
    if (this.data && this.data.cardAdms) {
      this.cardAdms = data.cardAdms
    }
  }

  public close(save: boolean){
    this.dialogRef.close(save ? (this.selectedAdm.id || '') : null);
  }

}


